export default "__VITE_ASSET__B1j$Ca2F__"